$(function () {
  $('a[href^="#"]').on('click', function(e) {
        e.preventDefault();
        var target = $(this.hash);
        $('html, body').animate({
            scrollTop: target.offset().top - 140
        }, 800);
    });
})

$(function () {
  // Virtual Appointments Page
  $(".virtualContentBox .condition .btn").click(function () {
    var _data = $(this).attr("data-name");
    $(".virtualContentBox .condition .btn").removeClass("on");
    $(this).addClass("on");
    $(".virtualContentBox .condition .switch").removeClass("on");
    $(".virtualContentBox .condition .switch[data-name="+_data+"]").addClass("on");
  });

  // Homecoming dresses
  $(".homeComingDressesBox6 .item h3").click(function(){
    $(this).toggleClass("active");
    $(this).next("div.text").slideToggle();
  });
  $("#homeComingDresses .productSlick").slick({
    dots: false,
    arrows: true,
    touchMove: false,
    speed: 300,
    slidesToShow: 5,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 999,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 750,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 640,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        }
      }
    ]
  });

  // Prom Dresses
  $('#promDresses .conBox2 .itemBox').slick({
    dots: false,
    arrows: true,
    touchMove: false,
    speed: 300,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 999,
        settings: {
          slidesToShow: 3
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1
        }
      }
    ]
  });
  $('#promDresses .conBox6 .imgBox').slick({
    dots: false,
    arrows: true,
    touchMove: false,
    speed: 300,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 999,
        settings: {
          slidesToShow: 3
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1
        }
      }
    ]
  });
  $("#promDresses .conBox7 .item h3").click(function(){
    $(this).next("div.text").slideToggle();
  });

  // Ever-Pretty Coupons & Promotions
  $(".coupons_promotions_tab_content .tabBox .tab").click(function () {
    let _data = $(this).attr("data-name");
    $(".coupons_promotions_tab_content .tabBox .tab").removeClass("on");
    $(this).addClass("on");
    $(".coupons_promotions_tab_content .switchBox .switch").removeClass("on");
    $(".coupons_promotions_tab_content .switchBox .switch[data-name="+ _data +"]").addClass("on");
  })
});

// bridesmaid dresses
$(document).ready(function() {
  var mySwiper = new Swiper ('.color_filter', {
    slidesPerView: 12,
    paginationClickable: true,
    freeMode: true,
    scrollbar: '.swiper-scrollbar',
    breakpoints: {
      300: {
        slidesPerView: 4,
      },
      540: {
        slidesPerView: 5,
      },
      740: {
        slidesPerView: 7,
      },
      999: {
        slidesPerView: 9,
      },
      1200: {
        slidesPerView: 12,
      },
      1400: {
        slidesPerView: 12,
      }
    }
  });

  var ww = $(window).width();
  if(ww <= 999){
    $('.color-item').click(function() {
      console.log(ww,'click this');
        var $this = $(this);
        var $colorImgBox = $this.find('.color-img-box');
        var $colorListBox = $this.find('.color-list-box');
        var $img = $colorImgBox.find('span');

        
        if($this.hasClass('color-list-active')){
          $colorListBox.hide();
          $this.removeClass('color-list-active');
  
          $img.css({ width: '70px', height: '70px' });
  
          var $prevItem = $this.prev('.color-item');
          var $nextItem = $this.next('.color-item');
          
          if ($prevItem.length) $prevItem.find('.color-img-box span').css({ width: '60px', height: '60px' });
          if ($nextItem.length) $nextItem.find('.color-img-box span').css({ width: '60px', height: '60px' });
        }else{
          $('.color-item').find('.color-list-box').hide();
          $colorListBox.show();
          $('.color-item').removeClass('color-list-active');
          $this.addClass('color-list-active');
  
          $('.color-item').not($this).find('.color-img-box span').css({ width: '60px', height: '60px' });
          $img.css({ width: '70px', height: '70px' });
  
          var $prevItem = $this.prev('.color-item');
          var $nextItem = $this.next('.color-item');
          
          if ($prevItem.length) $prevItem.find('.color-img-box span').css({ width: '65px', height: '65px' });
          if ($nextItem.length) $nextItem.find('.color-img-box span').css({ width: '65px', height: '65px' });
  
          if (($this.is(':first-child') || $this.is(':nth-child(2)'))) $colorListBox.css({ left: '0', right: 'auto', transform: 'translateX(0)' });
          else if ($this.is(':last-child') || $this.is(':nth-last-child(2)')) $colorListBox.css({ left: 'auto', right: '0', transform: 'translateX(0)' });
          else $colorListBox.css({ left: '50%', transform: 'translateX(-50%)' });
        }
        
    });
  }else{
    $('.color-item').on('mouseenter', function() {
      console.log(ww,'mouseenter this');
        var $this = $(this);
        var $colorImgBox = $this.find('.color-img-box');
        var $colorListBox = $this.find('.color-list-box');
        var $img = $colorImgBox.find('span');

        $colorListBox.show();
        $this.addClass('color-list-active');

        $('.color-item').not($this).find('.color-img-box span').css({ width: '60px', height: '60px' });
        $img.css({ width: '70px', height: '70px' });

        var $prevItem = $this.prev('.color-item');
        var $nextItem = $this.next('.color-item');
        
        if ($prevItem.length) $prevItem.find('.color-img-box span').css({ width: '65px', height: '65px' });
        if ($nextItem.length) $nextItem.find('.color-img-box span').css({ width: '65px', height: '65px' });

        if (($this.is(':first-child') || $this.is(':nth-child(2)'))) $colorListBox.css({ left: '0', right: 'auto', transform: 'translateX(0)' });
        else if ($this.is(':last-child') || $this.is(':nth-last-child(2)')) $colorListBox.css({ left: 'auto', right: '0', transform: 'translateX(0)' });
        else $colorListBox.css({ left: '50%', transform: 'translateX(-50%)' });
    });

    $('.color-item').on('mouseleave', function() {
      console.log(ww,'mouseleave this');
        var $this = $(this);
        var $colorImgBox = $this.find('.color-img-box');
        var $colorListBox = $this.find('.color-list-box');
        var $img = $colorImgBox.find('span');

        $colorListBox.hide();
        $this.removeClass('color-list-active');

        $img.css({ width: '60px', height: '60px' });

        var $prevItem = $this.prev('.color-item');
        var $nextItem = $this.next('.color-item');
        
        if ($prevItem.length) $prevItem.find('.color-img-box span').css({ width: '60px', height: '60px' });
        if ($nextItem.length) $nextItem.find('.color-img-box span').css({ width: '60px', height: '60px' });
    });
  }
})
$(function () {
  let ww = $(window).width();
  $(".bridesmaidBox1 .itemBox").slick({
    dots: false,
    arrows: true,
    touchMove: false,
    speed: 300,
    slidesToShow: 8,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 999,
        settings: {
          slidesToShow: 6,
        }
      },
      {
        breakpoint: 750,
        settings: {
          slidesToShow: 4,
        }
      }
    ]
  });
  $(".bridesmaidBox3 .itemBox").slick({
    dots: false,
    arrows: true,
    touchMove: false,
    speed: 300,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 999,
        settings: {
          centerMode: true,
          slidesToShow: 3,
        }
      },
      {
        breakpoint: 480,
        settings: {
          centerMode: true,
          centerPadding: '50px',
          slidesToShow: 1,
        }
      }
    ]
  });
  if(ww <=1199){
    $(".bridesmaidBox6 .itemBox").slick({
      dots: false,
      arrows: true,
      touchMove: false,
      speed: 300,
      slidesToShow: 1,
      slidesToScroll: 1,
      centerMode: true,
      variableWidth: true
    })
  }

  $(".bridesmaidBox5 .tp").click(function () {
    $(this).parent().next("div.pofText").show();
  });

  $(".bridesmaidBox5 .pofText").find("span").click(function () {
    $(this).parent("div.pofText").hide();
  });

  $(".bridesmaid_fabric .product_list").slick({
    dots: false,
    arrows: true,
    infinite: true,
    touchMove: false,
    speed: 500,
    autoplay: true,
    autoplaySpeed: 4000,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 3
        }
      },
      {
        breakpoint: 640,
        settings: {
          slidesToShow: 2
        }
      }
    ]
  });
});

// Prom Dresses
$(function () {
  $('.promDressesBox1Slick').slick({
    dots: false,
    arrows: true,
    touchMove: false,
    speed: 300,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 999,
        settings: {
          slidesToShow: 3
        }
      }
    ]
  });

  $('.promColorSlick').slick({
    dots: false,
    arrows: true,
    touchMove: false,
    speed: 300,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 640,
        settings: {
          slidesToShow: 3
        }
      }
    ]
  });

  $('.promDressesBox3 .itemBox').slick({
    dots: true,
    arrows: false,
    touchMove: false,
    speed: 300,
    slidesToScroll: 1,
    variableWidth: true,
  });

  $('.promDressesBox6 .imgBox').slick({
    dots: false,
    arrows: true,
    touchMove: false,
    speed: 300,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 640,
        settings: {
          slidesToShow: 2
        }
      }
    ]
  });
});

// Formal Dresses
$(function () {
  $(".formalDressesBox1Slick").slick({
    dots: false,
    arrows: true,
    touchMove: false,
    speed: 300,
    slidesToShow: 3,
    slidesToScroll: 1,
    centerMode: true,
    centerPadding: 0,
    responsive: [
      {
        breakpoint: 640,
        settings: {
          dots: false,
          arrows: true,
          touchMove: false,
          speed: 300,
          slidesToShow: 2,
          slidesToScroll: 1,
        }
      }
    ]
  });
  $(".formalColorSlick").slick({
    dots: false,
    arrows: true,
    touchMove: false,
    speed: 300,
    slidesToShow: 10,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 8
        }
      },
      {
        breakpoint: 999,
        settings: {
          slidesToShow: 6
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 5
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 3
        }
      }
    ]
  });
  $(".formalDressesProductSlick").slick({
    dots: false,
    arrows: true,
    touchMove: false,
    speed: 300,
    slidesToShow: 2,
    slidesToScroll: 1,
  });
  $(".formalDressesInfoSlick").slick({
    dots: false,
    arrows: true,
    touchMove: false,
    speed: 300
  });
  $(".formalDressesBox6 .itemBox").slick({
    dots: false,
    arrows: true,
    touchMove: false,
    speed: 300,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 750,
        settings: {
          dots: false,
          arrows: true,
          touchMove: false,
          speed: 300,
          slidesToShow: 2,
          slidesToScroll: 1,
        }
      }
    ]
  });
});

// Wedding Guest Dresses
$(function () {
  $(".weddingGuestColorSlick").slick({
    dots: false,
    arrows: true,
    touchMove: false,
    speed: 300,
    slidesToShow: 8,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 8
        }
      },
      {
        breakpoint: 999,
        settings: {
          slidesToShow: 6
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 5
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 3
        }
      }
    ]
  });

  $(".weddingGuestDressesBox3 .listBox .list").hover(function () {
    let _data = $(this).attr("data-name");
    $(".weddingGuestDressesBox3 .item").removeClass("on");
    $(".weddingGuestDressesBox3 .item[data-name="+_data+"]").addClass("on");
  });

  $(".weddingGuestDressesProductSlick").slick({
    dots: false,
    arrows: true,
    touchMove: false,
    speed: 300,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 640,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        }
      }
    ]
  });

  $(".weddingGuestDressesPhotoGallery").slick({
    dots: false,
    arrows: true,
    touchMove: false,
    speed: 300,
    slidesToShow: 5,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 999,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 750,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 640,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        }
      }
    ]
  });

  let ww = $(window).width();
  if(ww<=750){
    $(".weddingGuestDressesBox3 .itemBox").slick({
      dots: false,
      arrows: true,
      touchMove: false,
      speed: 300
    });
  }
});


// Evening Dresses & Gowns Guides
$(function(){
  $(".motherBrideDressesBox9 .item h3").click(function(){
    $(this).toggleClass("active");
    $(this).next("div.text").slideToggle();
  });
  $(".emPhotoSlick").slick({
    dots: false,
    arrows: true,
    infinite: true,
    touchMove: false,
    speed: 500,
    autoplay: true,
    autoplaySpeed: 4000,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 999,
        settings: {
          slidesToShow: 2
        }
      }
    ]
  });
  $(".emReviewSlick").slick({
    dots: false,
    arrows: true,
    infinite: true,
    touchMove: false,
    speed: 500,
    autoplay: true,
    autoplaySpeed: 4000,
    slidesToShow: 2,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 999,
        settings: {
          slidesToShow: 1
        }
      }
    ]
  });
});



$(function () {
  $("#eveningDressGuide .eveConBox2 .itemBox").slick({
    dots: false,
    arrows: true,
    infinite: true,
    touchMove: false,
    speed: 500,
    autoplay: true,
    autoplaySpeed: 4000,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 3
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2
        }
      }
    ]
  });
  $("#eveningDressGuide .eveConBox3 .itemBox").slick({
    dots: false,
    arrows: true,
    infinite: true,
    touchMove: false,
    speed: 500,
    autoplay: true,
    autoplaySpeed: 4000,
    slidesToShow: 5,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 3
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2
        }
      }
    ]
  });
});


function countdown() {
  var _data = $(".countdownTime").attr("data-time")
  var targetDate = new Date(_data);
  var currentDate = new Date();
  var remainingTime = targetDate.getTime() - currentDate.getTime();
  if (remainingTime <= 0) {
    $(".countdownTime").text("This event has ended");
    return;
  }
  var days = Math.floor(remainingTime / (1000 * 60 * 60 * 24));
  var hours = Math.floor((remainingTime % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
  var minutes = Math.floor((remainingTime % (1000 * 60 * 60)) / (1000 * 60));
  var seconds = Math.floor((remainingTime % (1000 * 60)) / 1000);
  var formattedDays = days < 10 ? "0" + days : days;
  var formattedHours = hours < 10 ? "0" + hours : hours;
  var formattedMinutes = minutes < 10 ? "0" + minutes : minutes;
  var formattedSeconds = seconds < 10 ? "0" + seconds : seconds;
  $(".countdownTime #days").text(formattedDays);
  $(".countdownTime #hours").text(formattedHours);
  $(".countdownTime #minutes").text(formattedMinutes);
  $(".countdownTime #seconds").text(formattedSeconds);

  setTimeout(countdown, 1000);
}

$(document).ready(function() {
  countdown();
});




$(function () {
  let ww = $(window).width();
  if(ww <= 640){
    $(".black-friday-event-2023 .bk-calendar .item .box").click(function () {
      $(this).parent("div.item").addClass("on");
    })
  }
  $(".black-friday-event-2023 .bk-best .itemBox").slick({
    dots: false,
    arrows: true,
    infinite: true,
    touchMove: false,
    speed: 500,
    autoplay: true,
    autoplaySpeed: 4000,
    slidesToShow: 6,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1220,
        settings: {
          slidesToShow: 5
        }
      },
      {
        breakpoint: 999,
        settings: {
          slidesToShow: 4
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 3
        }
      },
      {
        breakpoint: 640,
        settings: {
          slidesToShow: 2
        }
      }
    ]
  });
  $(".black-friday-event-2023 .bk-collection .itemBox").slick({
    dots: true,
    arrows: false,
    touchMove: false,
    speed: 1000,
    rows: 2,
    slidesToShow: 4,
    slidesToScroll: 2,
    responsive: [
      {
        breakpoint: 999,
        settings: {
          slidesToShow: 2
        }
      }
    ]
  });
  $(".cyber-collection .itemBox").slick({
    dots: true,
    arrows: false,
    touchMove: false,
    speed: 1000,
    rows: 2,
    slidesToShow: 4,
    slidesToScroll: 2,
    responsive: [
      {
        breakpoint: 999,
        settings: {
          slidesToShow: 2
        }
      }
    ]
  });
});




$(function () {
  $(".holiday_dresses_template .color_trend .product_list").slick({
    dots: false,
    arrows: true,
    infinite: true,
    touchMove: false,
    speed: 500,
    autoplay: true,
    autoplaySpeed: 4000,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 3
        }
      },
      {
        breakpoint: 640,
        settings: {
          slidesToShow: 2
        }
      }
    ]
  });
  $(".holiday_dresses_template .discounts_offers .itemBox").slick({
    dots: false,
    arrows: true,
    infinite: true,
    touchMove: false,
    speed: 500,
    autoplay: true,
    autoplaySpeed: 4000,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 3
        }
      },
      {
        breakpoint: 640,
        settings: {
          slidesToShow: 2
        }
      }
    ]
  });


  $(".black-friday-event-2023 .bk-winter .itemBox").slick({
    dots: false,
    arrows: true,
    infinite: true,
    touchMove: false,
    speed: 500,
    autoplay: true,
    autoplaySpeed: 4000,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 750,
        settings: {
          slidesToShow: 3
        }
      }
    ]
  });
  $('.bk-discount span').click(function() {
    var data_code = $(this).attr("data-code");
    navigator.clipboard.writeText(data_code);
    var originalTitle = $(this).attr('title');
    $(this).attr('title', 'Copied successfully');
    setTimeout(function() {
      $(this).attr('title', originalTitle);
    }.bind(this), 5000);
  });
});


// Group Template
$(function(){
  $("#groupBuyBox .box2 .item .tpBox a").click(function () {
    var _data = $(this).attr("data-name");
    $("#groupBuyBox .box2 .item .conBox, #groupBuyBox .box2 .item .text").removeClass("active");
    $("#groupBuyBox .box2 .item .text[data-name="+ _data +"]").addClass("active");
    $(this).parent().parent().parent().addClass("active");
  });
  $(".close-this").click(function () {
    $("#groupBuyBox .box2 .item .conBox, #groupBuyBox .box2 .item .text").removeClass("active");
  });

  $(".choir_shop_faq .item h3").click(function(){
    $(this).toggleClass("active");
    $(this).next("div.text").slideToggle();
  });



  $(".groupTemplateBox .groupService .item .btn").click(function () {
    var _data = $(this).attr("data-name");
    $(".groupTemplateBox .groupService .item .conBox, .groupTemplateBox .groupService .item .tBox").removeClass("active");
    $(".groupTemplateBox .groupService .item .tBox[data-name="+ _data +"]").addClass("active");
    $(this).parent().parent().parent().parent().addClass("active");
  });
  $(".groupService .close-this").click(function () {
    $(".groupTemplateBox .groupService .item .conBox, .groupTemplateBox .groupService .item .tBox").removeClass("active");
  });

  $(".groupDiscount .title a").click(function () {
    $(".groupDiscount, .groupDiscount .popBox").removeClass("active");
    $(".groupDiscount .popBox").addClass("active");
    $(".groupDiscount").addClass("active");
  });
  $(".groupDiscount .close-this").click(function () {
    $(".groupDiscount, .groupDiscount .popBox").removeClass("active");
  });

  $('.groupProduct .itemBox').slick({
    dots: false,
    arrows: true,
    infinite: true,
    touchMove: false,
    speed: 500,
    autoplay: true,
    autoplaySpeed: 4000,
    slidesToShow: 5,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 3
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2
        }
      }
    ]
  });

  $('.groupTemplateBox .gallerySlick').slick({
    dots: false,
    arrows: true,
    infinite: true,
    speed: 300,
    slidesToShow: 1,
    centerMode: true,
    touchMove: false,
    variableWidth: true
  });


  $(".group_hot_sale .itemBox").slick({
    dots: false,
    arrows: true,
    touchMove: false,
    speed: 300,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 999,
        settings: {
          centerMode: true,
          slidesToShow: 3,
        }
      },
      {
        breakpoint: 767,
        settings: {
          centerMode: true,
          slidesToShow: 2,
        }
      },
      {
        breakpoint: 540,
        settings: {
          centerMode: true,
          centerPadding: '50px',
          slidesToShow: 1,
        }
      }
    ]
  });
});

// Valentine's Day
$(function () {
  $(".popular_trend .product_list").slick({
    dots: false,
    arrows: true,
    infinite: true,
    touchMove: false,
    speed: 500,
    autoplay: true,
    autoplaySpeed: 4000,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 3
        }
      },
      {
        breakpoint: 640,
        settings: {
          slidesToShow: 2
        }
      }
    ]
  });

  $(".loadmore").click(function(){
    $(this).hasClass("active") ? $(this).text("Load More").removeClass("active") : $(this).text("See Less").addClass("active");
    $(this).parent("div.text").toggleClass("active");
  })
})


// new wedding guest
$(function(){
  $(".weddingGuest_style .text").eq(0).addClass("on");
  $(".weddingGuest_style .image").eq(0).addClass("on");
  

  $(".weddingGuest_style .text").hover(function () {
    let _data = $(this).attr("data-name");
    $(".weddingGuest_style .image").removeClass("on");
    $(".weddingGuest_style .image[data-name="+_data+"]").addClass("on");
  });
  
  $(".weddingGuest_season .itemBox").slick({
    dots: false,
    arrows: true,
    touchMove: false,
    speed: 300,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 999,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 640,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        }
      }
    ]
  });

  $('.weddingGuest_colors .itemBox').slick({
    dots: false,
    arrows: true,
    touchMove: false,
    speed: 300,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 999,
        settings: {
          slidesToShow: 3
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2
        }
      }
    ]
  });
  $('.weddingGuest_photos .imgBox').slick({
    dots: false,
    arrows: true,
    touchMove: false,
    speed: 300,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 999,
        settings: {
          slidesToShow: 3
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1
        }
      }
    ]
  });
});


$(function () {
  $(".military_faq .item").click(function () {
    if($(this).hasClass("on")){
      $(this).removeClass("on");
      $(this).find(".text").slideUp();
    }else{
      $(".military_faq .item").removeClass("on");
      $(this).addClass("on");
      $(".military_faq .item").find(".text").slideUp();
      $(this).find(".text").slideDown(); 
    }
  });

  $(".military_photos .imageBox").slick({
    dots: false,
    arrows: true,
    touchMove: false,
    speed: 1000,
    autoplay: true,
    autoplaySpeed: 8000,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 999,
        settings: {
          dots: true,
          slidesToShow: 3
        }
      },
      {
        breakpoint: 767,
        settings: {
          dots: true,
          slidesToShow: 2
        }
      },
      {
        breakpoint: 540,
        settings: {
          dots: true,
          slidesToShow: 1
        }
      }
    ]
  })
});


// black friday 2024
$(function () {
  $(".code_80_off .itemBox").slick({
    dots: false,
    arrows: true,
    infinite: true,
    touchMove: false,
    speed: 500,
    autoplay: true,
    autoplaySpeed: 4000,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1
        }
      },
      {
        breakpoint: 640,
        settings: {
          slidesToShow: 2
        }
      }
    ]
  });
  $(".bk-best .itemBox").slick({
    dots: false,
    arrows: true,
    infinite: true,
    touchMove: false,
    speed: 500,
    autoplay: true,
    autoplaySpeed: 4000,
    slidesToShow: 6,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 999,
        settings: {
          slidesToShow: 4
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 3
        }
      },
      {
        breakpoint: 640,
        settings: {
          slidesToShow: 2
        }
      }
    ]
  });
  $('.bk-discount span').click(function() {
    var data_code = $(this).attr("data-code");
    navigator.clipboard.writeText(data_code);
    var originalTitle = $(this).attr('title');
    $(this).attr('title', 'Copied successfully');
    setTimeout(function() {
      $(this).attr('title', originalTitle);
    }.bind(this), 5000);
  });
  $(".bk-collection .itemBox").slick({
    dots: true,
    arrows: false,
    touchMove: false,
    speed: 1000,
    rows: 2,
    slidesToShow: 4,
    slidesToScroll: 2,
    responsive: [
      {
        breakpoint: 999,
        settings: {
          slidesToShow: 2
        }
      }
    ]
  });
  $(".bk-faq .item h3").click(function(){
    $(this).toggleClass("active");
    $(this).next("div.text").slideToggle();
  });
});

$(function () {
  var about_story = new Swiper(".about--history .itemBox", {
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    breakpoints: {
      1201: {
        slidesPerView: 4,
      },
      1000: {
        slidesPerView: 3,
      },
      741: {
        slidesPerView: 2,
      },
      740: {
        slidesPerView: 1,
      }
    }
  });
  var about_story = new Swiper(".story--item", {
    spaceBetween: 40,
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    breakpoints: {
      1201: {
        slidesPerView: 2
      },
      1200: {
        slidesPerView: 1,
      }
    }
  });
});


// index Review
  $('.indexReviewSlick').slick({
    dots: false,
    arrows: true,
    touchMove: false,
    speed: 1000,
    autoplay: true,
    autoplaySpeed: 8000,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 3
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2
        }
      },
      {
        breakpoint: 540,
        settings: {
          slidesToShow: 1
        }
      }
    ]
  });

$(function () {
  var ww = $(window).width();
  if(ww<=1000){
    $("#color-items").slick({
      slidesToShow: 7,
      slidesToScroll: 3,
      arrows: false,
      touchMove: false,
      dots: false,
      centerMode: true,
  	  centerPadding: '0',
      focusOnSelect: true,
      responsive: [
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 5
          }
        }
      ]
    });

    $('#color-items').on('click', '.item', function(){
      var $this = $(this);
      if ($this.hasClass('active')) {
        $this.removeClass('active');
      } else {
        $('#color-items .item').removeClass('active');
        $this.addClass('active'); 
      }
    });
  }
})



$(document).ready(function () {
  $('.champagne-bridesmaid-swiper').each(function () {
    var swiperInstance = new Swiper(this, {
      slidesPerView: 2,
      spaceBetween: 15,
      grabCursor: true,
      centeredSlides: false,
      paginationClickable: true,
      freeMode: true,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      breakpoints: {
        640: {
          slidesPerView: 3,
        },
        740: {
          slidesPerView: 2.2,
        },
        1000: {
          slidesPerView: 3.8,
        },
        1400: {
          slidesPerView: 3.5,
        },
      },
    });

    $(this).data('swiper-instance', swiperInstance);
  });

  setTimeout(function () {
    var $alt_color = $('.shop_style .listBox').attr("data-color");

    $(".shop_style .product-item-meta__swatch-list")
      .find('div.color-swatch[data-colortip="' + $alt_color + '"]')
      .each(function () {
        var scrollTop = $(window).scrollTop();
        var scrollLeft = $(window).scrollLeft();
        $(this).find('label').click();

        $('.champagne-bridesmaid-swiper').each(function () {
          var swiper = $(this).data('swiper-instance');
          if (swiper) {
            swiper.slideTo(0, 0);
          }
        });
        
        $(window).scrollTop(scrollTop);
        $(window).scrollLeft(scrollLeft);
      });
  }, 100);
});



 $(document).ready(function() {
  $('.faqSection .list h3').on('click', function() {
    const $parent = $(this).parent('.list');
    const $content = $(this).next('.text');
    $parent.toggleClass('active');
    $content.stop().slideToggle(300); 
  });
});